<template>
    <div class="shopcart notranslate">
     
        <div class="content">
            <div class="content-left">
                <div class="logo-wrapper" @click="toggleList()">
                    <div class="logo" :class="{'highlight': totalCount > 0} ">
                        <mu-button fab small color="primary" :class="{'highlight': totalCount > 0}" style="width:45px;height:45px;">
                            <mu-icon value="local_grocery_store"></mu-icon>
                        </mu-button>
                    </div>
                    <div class="num" v-show="totalCount">{{totalCount}}</div>
                </div>
                <span class="price" :class="{'highlight': totalPrice > 0}">{{totalPrice}} {{seller.unit}}</span>
                <!--<span class="desc" v-if="isSeft==1" @click="toggleSummaryList">{{totalSeveral}} all</span>-->
            </div>
            <div class="content-right">
                <div class="pay" style="background-color: rgb(218, 91, 58); color: #fff;" @click="openBill" v-if="isShowHistory">{{$t('buffet.checklist')}}</div>
            </div>
            <div class="content-right">
                <div class="pay enough" @click.stop.prevent="nextTo()">{{$t('buffet.next')}} ( {{totalSeveral}} )</div>
            </div>
        </div>
        <div class="ball-container">
            <transition-group name="drop" @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter">
                <div v-for="(ball, index) in balls" :key="index" v-show="ball.show" class="ball">
                    <span class="inner inner-hook"></span>
                </div>
            </transition-group>
        </div>
        <transition name="fold">
            <div class="shopcart-list" v-show="cartShow">
                <div class="list-header">
                    <span class="title">{{$t('buffet.cartList')}}</span>
                    <span class="desc" style="margin-left:30px;" v-if="isSeft==1" @click="toggleSummaryList">{{$t('buffet.total')}}:{{totalSeveral}} {{$t('buffet.share')}}</span>
                    <span class="empty" @click="toggleList">{{$t('common.close')}}</span>
                </div>
                <div class="list-content" ref="listContent">
                    <ul>
                        <li v-for="(food,index) in selectFoods" class="food" :key="index">
                            <div class="name">{{food.foodName}}
                                <div class="decide-name" v-if="food.decideName">{{food.decideName}}</div>
                            </div>
                              <div class="price" style="padding-right:10px;" v-if="food.chargedOnce==1">
                                {{Number(food.payAmount) * 1}} {{seller.unit}}
                            </div>
                            <div class="price" style="padding-right:10px;" v-else>
                                {{Number(food.payAmount) * food.quantity}} {{seller.unit}}
                            </div>
                            <div class="cartcontrol-wrapper" style="margin-bottom:5px;">
                                <cartcontrol :food="food" :add-type="addType"></cartcontrol>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
        <transition name="fold">
            <div class="shopcart-list" v-show="summaryShow">
                <div class="list-header">
                    <span class="title">{{$t('buffet.summary')}}</span>
                    <mu-icon value="compare_arrows" style="padding:10px;" color="green" @click="changeShowType"></mu-icon>
                    <span class="empty" @click="toggleSummaryList">{{$t('common.close')}}</span>
                </div>
                <div class="list-content" ref="summaryContent" style="padding:0px;" v-if="!sumListShow">
                    <mu-list>
                        <mu-list-item avatar v-for="group in listGroup" :key="group.foodTypeName" style="width:50%;float:left;padding:5px;">
                            <div style="margin-right:10px">
                                <img :src="getImgUrl(group.foodImage,200)" style="width:50px;height:50px;">
                            </div>
                            <mu-list-item-content>
                                <span>{{group.num}}</span>
                                <mu-list-item-title style="font-size:12px;min-width:max-content;">{{group.foodTypeName}}</mu-list-item-title>
                            </mu-list-item-content>
                        </mu-list-item>
                    </mu-list>
                </div>
                <div class="list-content" ref="summaryContent" v-if="sumListShow">
                    <ul>
                        <li v-for="group in listGroup" class="food" :key="group.foodTypeName" v-if="isSeft==1" >
                            <div class="name">{{group.foodTypeName}}</div>
                            <div class="price">
                                <span>
                                    {{group.num}}
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
        <transition name="mask-fade">
            <div class="list-mask" @click="hideMask" v-show="maskShow"></div>
        </transition>

        <mu-bottom-sheet :open.sync="billOpen" style="height:100%;">
            <mu-list @item-click="closeBill" style="overflow-y: scroll;height:100%;">
                <div class="ower" v-show="!showOrderTip">
                    <span class="badge-num" :class="{select:current==-1}" @click="selectOwerCartlist(-1,null)">All</span>
                    <span class="badge-num" :class="{select:index==current}" @click="selectOwerCartlist(index,val)" v-for="(val, key, index) in cartOwerData" :key="index">{{key.replace(/\"/g,"")}}</span>
                </div>
                <div style="right: 10px; position: absolute; z-index: 100; margin-top: -15px; ">
                    <mu-button color="success" v-if="reminderBtnShow" class="notranslate" @click="addReminder" style="text-transform:unset;">{{$t('buffet.reminder')}}</mu-button>
                </div>

                <mu-list v-show="!showOrderTip">
                    <mu-list-item style="height:45px;margin:5px auto;padding-right:5px;">
                        <mu-list-item-content>
                            <div style="float:right;font-size:16px;font-weight:600;">{{$t('buffet.total')}}: <span class="now" style="font-size:16px;color:#e53935;">{{total}} {{seller.unit}}</span></div>
                        </mu-list-item-content>
                    </mu-list-item>
                </mu-list>
                <div v-show="!showOrderTip">
                    <mu-expansion-panel v-for="(value, k, i) in cartBuffetShowData" :key="i" style="width:100%;" :zDepth="0" :expand="true">
                        <div slot="header" style="width:100%;">{{getOrderTimes(k)}} </div>
                        <div class="cart-box" style="margin-top:5px;" v-for="(val, key, index) in getTypeGroup(value)" :key="index">
                            <mu-list>
                                <mu-list-item style="height:36px;">
                                    <mu-list-item-content>
                                        <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                                    </mu-list-item-content>
                                </mu-list-item>
                                <mu-divider shallow-inset></mu-divider>
                                <mu-list-item style="height:40px;margin:20px auto;" v-for="item,index in val" :key="index">
                                    <!--<div class="marker-red" v-if="item.serveState==0"></div>
                                    <div class="marker-green" v-if="item.serveState==1"></div>-->
                                    &nbsp;
                                    <mu-flex>
                                        <mu-avatar style="width: 60px !important;">
                                            <img :src="getImgUrl(item.foodImage,200)" style="border-radius:0;">
                                        </mu-avatar>
                                    </mu-flex>
                                    <mu-list-item-content>
                                        <div style="margin-left: 5px;">
                                            <div style="float:left;">
                                                <div style="font-size:12px;height:24px;line-height:24px;">
                                                    {{item.foodName}}

                                                    <mu-badge content="waiting" v-if="item.serveState==0" color="#dd514c"></mu-badge>
                                                    <mu-badge content="serving" v-if="item.serveState==1" color="#F37B1D"></mu-badge>
                                                    <mu-badge content="finish" v-if="item.serveState==2" color="#4CAF50"></mu-badge>
                                                </div>

                                            </div>
                                            <div class="cart-opration" style="float:right;">
                                                <span class="now">x {{item.quantity}} </span>
                                                <!--<div>
                                    <mu-switch v-model="item.serveState" @change="updateServeState(2,item)" label=""></mu-switch>
                                    </div>-->
                                            </div>
                                        </div>
                                    </mu-list-item-content>
                                </mu-list-item>
                            </mu-list>
                        </div>
                    </mu-expansion-panel>
                </div>

                <div class="cart-box" style="margin-top:5px;padding-left:5px;padding-right:5px;" v-for="(val, key, index) in cartShowData" :key="index" v-show="!showOrderTip">
                    <mu-list>
                        <mu-list-item style="height:36px;">
                            <mu-list-item-content>
                                <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                            </mu-list-item-content>
                        </mu-list-item>
                        <mu-divider shallow-inset></mu-divider>
                        <mu-list-item style="height:40px;margin:20px auto;" v-for="item,index in val" :key="index">
                            <!--<div class="marker-red" v-if="item.serveState==0"></div>
                            <div class="marker-green" v-if="item.serveState==1"></div>-->
                            &nbsp;
                            <mu-flex>
                                <mu-avatar style="width: 60px !important;">
                                    <img :src="getImgUrl(item.foodImage,200)" style="border-radius:0;">
                                </mu-avatar>
                            </mu-flex>
                            <mu-list-item-content>
                                <div style="margin-left: 5px;">
                                    <div style="float:left;">
                                        <div style="font-size:12px;height:24px;line-height:24px;">
                                            {{item.foodName}}
                                            <mu-badge content="waiting"  v-if="item.serveState==0"   color="#dd514c"></mu-badge> 
                                            <mu-badge content="serving" v-if="item.serveState==1"  color="#F37B1D"></mu-badge> 
                                            <mu-badge content="finish" v-if="item.serveState==2"  color="#4CAF50"></mu-badge>
                                        </div>
                                        <div>
                                            <span class="now">{{ item.payAmount }} {{seller.unit}}</span>
                                            <span>x {{ item.quantity }}</span>
                                        </div>
                                    </div>
                                     <div class="cart-opration" style="float:right;color:#e53935;" v-if="item.chargedOnce==1">
                                        <span class="now"> {{item.payAmount}} {{seller.unit}}</span>
                                    </div>
                                    <div class="cart-opration" style="float:right;color:#e53935;" v-else>
                                        <span class="now"> {{item.quantity * item.payAmount}} {{seller.unit}}</span>
                                    </div>
                                </div>
                            </mu-list-item-content>
                        </mu-list-item>
                    </mu-list>
                </div>
                <mu-list>
                    <mu-list-item style="height:60px;margin:5px auto;">
                        <mu-list-item-content>
                        </mu-list-item-content>
                    </mu-list-item>
                </mu-list>
                <!--<mu-button large fab color="green" class="btn-home" >
        <div>
            <div>
                <mu-icon value="reply"></mu-icon>
            </div>
            <div>
                {{$t('common.back')}}
            </div>
        </div>
    </mu-button>-->
            <div class="oprations" v-show="true">
                <div class="oprations-btn">
                    <div class="oprations-back" @click="closeBill">{{$t('common.back')}}</div>
                </div>
                <div class="oprations-btn">
                    <div class="oprations-next enough" @click="serviced">{{$t('buffet.served')}}</div>
                </div>
                <div class="oprations-btn">
                    <div class="oprations-next not-enough" @click="unServiced">{{$t('buffet.nserved')}}</div>
                </div>
            </div>

                <div style="width: 100%; background: #fff; padding: 20px;text-align:center;padding-top:60px;" v-show="showOrderTip">
                    <mu-flex class="flex-wrapper" justify-content="center">
                        <div style="font-size:16px;font-weight:600;color:#DA5B3A;">{{$t('buffet.nullOrder')}}</div>
                    </mu-flex>
                    <mu-flex class="flex-wrapper" justify-content="center">
                        <div style="width: 100%; text-align: center; margin-top: 30px;"><mu-button color="success" @click="closeBill" style="text-transform:unset;">{{$t('buffet.startOrder')}}</mu-button></div>
                    </mu-flex>
                </div>

            </mu-list>
        </mu-bottom-sheet>
    </div>
</template>

<script>
  import { eventBus } from '../utils/event-bus'
  import cartcontrol from '../components/CartControl'
  import BScroll from 'better-scroll'

    export default {
        props: {
            isSeft: {
                type: Number,
                default: 0
            },
            packageType: {
                type: Number,
                default: 0
            },
            isSeftPay: {
                type: Number,
                default: 0
            },
            selectFoods: {
                type: Array,
                default() {
                    return []
                }
            },
            addType: {
                type: Boolean
            }
        },
        data() {
            return {
                balls: [
                    { show: false },
                    { show: false },
                    { show: false },
                    { show: false },
                    { show: false }
                ],
                dropBalls: [],
                fold: true,
                totalSeveral: 0,
                tableOrderInfo: {},
                seller:{},
                summary: false,
                maskShow: false,
                sumListShow: false,
                billOpen: false,
                cartList: [],
                groupCartBuffetList: [],
                groupCartList: [],
                isShowHistory: false,
                showOrderTip: false,
                cartShowData: [],
                cartBuffetShowData: {},
                total: 0,
                current: -1,
                cartOwerData: {},
                order: {},
                configsData:{},
                intervalId: null,
                reminderBtnShow: false,
            }
        },
        created() {
            // 优化体验，异步监听小球平抛动画
            this.$nextTick(() => {
                eventBus.$on('addcart', this.drop)
            })
        },
        mounted() {
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.getOrderList();
            this.getConfigs();
        },
        computed: {
            totalPrice() {
                let totalPrice = 0
                this.selectFoods.forEach((food) => {
                    if(food.chargedOnce==1){
                        totalPrice += food.payAmount;
                    }
                    else{
                        totalPrice += food.quantity * food.payAmount;
                    }
                })
                return totalPrice
            },
            totalCount() {
                let total = 0;
                this.selectFoods.forEach((food) => {
                    total += food.quantity
                })
                return total
            },
            listGroup() {
                let groupList = this.groupBy(this.selectFoods, function (item) {
                    return [item.foodTypeName];
                })
                let typeList = [];
                this.totalSeveral = 0;
                groupList.forEach((item) => {
                    let num = 0;
                    item.forEach((food) => {
                        num += food.quantity;
                        this.totalSeveral += food.quantity * food.several;
                    });
                    typeList.push({ foodTypeName: item[0].foodTypeName, foodImage: item[0].foodImage, num: num });
                });
                return typeList;
            },
            cartShow() {
                if (!this.totalCount) {
                    this.fold = true
                    return false
                }
                let show = !this.fold
                if (show) {
                    // 手动刷新better-scroll重新计算页面高度
                    if (!this.listContentScroll) {
                        this.listContentScroll = new BScroll(this.$refs.listContent, {
                            click: true
                        })
                    } else {
                        this.$nextTick(() => {
                            this.listContentScroll.refresh()
                        })
                    }
                }
                this.maskShow = show;
                return show
            },
            summaryShow() {
                if (!this.totalCount) {
                    this.summary = true
                    return false
                }
                let show = !this.summary
                if (show) {
                    // 手动刷新better-scroll重新计算页面高度
                    if (!this.summaryContentScroll) {
                        this.summaryContentScroll = new BScroll(this.$refs.summaryContent, {
                            click: true
                        })
                    } else {
                        this.$nextTick(() => {
                            this.summaryContentScroll.refresh()
                        })
                    }
                }
                this.maskShow = show;
                return show
            }
        },
        methods: {
           timestampToTime(date) {
                var dt = new Date(parseInt(date.replace(/.*Date\([^\d]*(\d+)[^\d]*\).*/, '$1')));
                return dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate() + " " + dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
            },
            dataRefreh() {
                if (this.intervalId != null) {
                    return;
                }
                this.intervalId = setInterval(() => {
                    if (this.configsData != undefined && this.configsData != null && this.order != null) {
                        let remindeTime = this.configsData.RemindeTime;
                        let dateTime = this.order.orderDay.replace('/Date(', '').replace(')/', '');
                        dateTime = this.timestampToTime(dateTime);
                        var dateTimeStamp = new Date(dateTime).getTime();
                        var now = new Date().getTime();
                        var diffValue = now - dateTimeStamp;
                        var minute = 1000 * 60;
                        var minC = diffValue / minute;
                        if (parseInt(minC) >= parseInt(remindeTime)) {
                            this.reminderBtnShow = true;
                        }
                        else {
                            this.reminderBtnShow = false;
                        }
                    }
                }, 2000);
            },
            destroyed() {
                this.clear();
            },
            clear() {
                clearInterval(this.intervalId);
                this.intervalId = null;
            },
            drop(ele) {
                for (let i = 0; i < this.balls.length; i++) {
                    let ball = this.balls[i]
                    if (!ball.show) {
                        ball.show = true // 表示可以有下落动画
                        ball.el = ele;
                        this.dropBalls.push(ball)
                        return // 跳出循环
                    }
                }
            },
            beforeEnter: function (ele) {
                let count = this.balls.length
                while (count--) {
                    let ball = this.balls[count]
                    if (ball.show) {
                        let rect = ball.el.getBoundingClientRect()
                        let x = rect.left - 32
                        let y = -(window.innerHeight - rect.top - 22)
                        ele.style.display = ''
                        ele.style.webkitTransform = `translate3d(0, ${y}px, 0)`
                        ele.style.transform = `translate3d(0, ${y}px, 0)`
                        let inner = ele.getElementsByClassName('inner-hook')[0]
                        inner.style.webkitTransform = `translate3d(${x}px, 0, 0)`
                        inner.style.transform = `translate3d(${x}px, 0, 0)`
                    }
                }
            },
        
            timeOutCheck() {
                let that = this;
                var time = window.localStorage.getItem('timeOut');
                if (time != undefined && time != null && time != "") {
                    var dateTimeStamp = new Date(time.replace(/-/g, '/')).getTime();
                    var now = new Date().getTime();
                    var diffValue = now - dateTimeStamp;
                    var minute = 1000 * 60;
                    var minC = diffValue / minute;
                    if (parseInt(minC) >= 120) {
                        this.$alert('The page is invalid. Please scan the QR code again!', 'Alert', {
                            type: 'warning', okLabel: 'Sure',}).then(function (result, value) {
                            that.$router.push({
                                path: '/error'
                            })
                        });
                        return false;
                    }
                    return true;
                }
                this.$alert('The page is invalid. Please scan the QR code again!', 'Alert', {
                    type: 'warning', okLabel: 'Sure',
                }).then(function (result, value) {
                    that.$router.push({
                        path: '/error'
                    })
                });
                return false;

            },
            enter: function (ele) {
                /* eslint-disable */
                ele.offsetHeight
                this.$nextTick(() => {
                    ele.style.webkitTransform = 'translate3d(0, 0, 0)'
                    ele.style.transform = 'translate3d(0, 0, 0)'
                    let inner = ele.getElementsByClassName('inner-hook')[0]
                    inner.style.webkitTransform = 'translate3d(0, 0, 0)'
                    inner.style.transform = 'translate3d(0, 0, 0)'
                })
            },
            afterEnter: function (ele) {
                let ball = this.dropBalls.shift();
                if (ball) {
                    ball.show = false
                    ele.style.display = 'none'
                }
            },
            hideMask() {
                this.hideList();
                this.hideSummaryList();
            },
            toggleList() {
                if (!this.totalCount) {
                    return
                }
                this.fold = !this.fold
            },
            hideList() {
                this.fold = true
            },
            toggleSummaryList() {
                if (!this.totalCount) {
                    return
                }
                this.summary = !this.summary
            },
            hideSummaryList() {
                this.summary = true
            },
            empty() {
                this.selectFoods.forEach((food) => {
                    food.quantity = 0
                })
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            nextTo() {
                if (!this.timeOutCheck()) {
                    return;
                }
                var cartList = [];
                this.selectFoods.forEach((food) => {
                    cartList.push({
                        RelatedId:food.relatedId,
                        RestaurantId: this.tableOrderInfo.restaurantId,
                        TableName: this.tableOrderInfo.tableName,
                        FoodTypeId:food.foodTypeId,
                        FoodTypeName: food.foodTypeName,
                        FoodId: food.foodId,
                        FoodName: food.foodName,
                        FoodImage: food.foodImage,
                        Price: food.payAmount,
                        Quantity: food.quantity,
                        FoodDiscount: food.actDiscount,
                        AllowDiscounts: food.allowDiscounts,
                        DecideName: food.decideName == undefined ? "" : food.decideName,
                        CreateUser: this.tableOrderInfo.name,
                        CreatePhone: this.tableOrderInfo.telephone,
                        IsSeft: food.isSeftPay==1?0:1,
                        Remark: food.remark,
                        ChargedOnce: food.chargedOnce,
                    })
                })
                let param = {
                    RestaurantId: this.tableOrderInfo.restaurantId,
                    TableName: this.tableOrderInfo.tableName,
                    shopCartList: JSON.stringify(cartList)
                };
                this.maskShow = false;
                this.$post('QRCodeOrder/AddtoCartList', param)
                    .then(response => {
                        if (response.code==200) {
                            this.empty();
                            var url='/cartList';
                            if(this.tableOrderInfo.orderType==2){
                                url='takwawayCartList';
                            }
                            this.$router.push({
                                path: url
                                , query: {
                                    packageType: this.packageType,
                                    isSeft: this.isSeft,
                                    isSeftPay: this.isSeftPay
                                }
                            });
                        } else {
                            this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            groupOrerBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return groups;
            },
            groupBy: function (array, f) {
                let groups = {};
                array.forEach(function (o) {
                    let group = JSON.stringify(f(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return Object.keys(groups).map(function (group) {
                    return groups[group];
                });
            },
            changeShowType() {
                this.sumListShow = !this.sumListShow;
            },
            closeBill() {
                this.billOpen = false;
            },
            openBill() {
                this.getOrderList();
                this.billOpen = true;
            },
            updateServeState(type, item) {
                var menthUrl = 'UpdateOrderListServe';
                if (type == 2) {
                    menthUrl = 'UpdateOrderBuffetServe';
                }
                var param = {
                    OrderId: item.orderId,
                    FoodId: item.foodId,
                    ServeState: item.serveState ? 2 : 1
                }
                this.$post('QRCodeOrder/' + menthUrl, param)
                    .then(response => {
                        if (response.code == 200) {
                        }
                    })
            },
            async getConfigs() {
                await this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            response.data.forEach((item) => {
                                this.configsData[item.configKey]= item.configValue;
			                })
                        }
                    });
            },
            getOrderList() {
                this.total = 0;
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                this.showOrderTip = true;
                                return;
                            }
                            this.order = data;
                            this.dataRefreh();
                            this.tableOrderInfo.orderTime = this.order.orderDay.replace('/Date(', '').replace(')/', '');
                            this.$get('QRCodeOrder/GetQRcodeOrderList', { orderId: data.OrderId })
                                .then(result => {
                                    if (result.code == 200) {
                                        this.cartList = result.data;
                                        if (this.cartList.length == 0) {
                                            this.cartShowData = [];
                                            this.showOrderTip = true;
                                            return;
                                        }
                                        this.isShowHistory = true;
                                        this.total = 0;
                                        this.showOrderTip = false;
                                        for (var i = 0; i < this.cartList.length; i++) {
                                            this.total += (this.cartList[i].quantity * this.cartList[i].price);
                                        }

                                        this.cartOwerData = this.groupOrerBy(this.cartList, (cart) => {
                                            return cart.createUser
                                        });

                                        //汇总所有人数量
                                        var map = {},
                                            dest = [];
                                        for (var i = 0; i < this.cartList.length; i++) {
                                            var ai = this.cartList[i];
                                            var isHas = false;
                                            for (var j = 0; j < dest.length; j++) {
                                                var dj = dest[j];
                                                if (dj.foodId == ai.foodId && dj.batch == ai.batch) {
                                                    isHas = true;
                                                    dest.splice(j, 1);
                                                    dest.push({
                                                        OrderId: ai.orderId,
                                                        FoodId: ai.foodId,
                                                        FoodName: ai.foodName,
                                                        Price: ai.price,
                                                        FoodDiscount: ai.foodDiscount,
                                                        FoodImage: ai.foodImage,
                                                        FoodTypeName: ai.foodTypeName,
                                                        Quantity: ai.quantity + dj.quantity,
                                                        IsSeft: ai.isSeft,
                                                        Batch: ai.batch,
                                                        ServeState: ai.serveState,
                                                        ChargedOnce: ai.chargedOnce,
                                                    });
                                                    break;
                                                }
                                            }
                                            if (!isHas) {
                                                dest.push({
                                                    OrderId: ai.orderId,
                                                    FoodId: ai.foodId,
                                                    FoodName: ai.foodName,
                                                    Price: ai.price,
                                                    FoodDiscount: ai.foodDiscount,
                                                    FoodImage: ai.foodImage,
                                                    FoodTypeName: ai.foodTypeName,
                                                    Quantity: ai.quantity,
                                                    IsSeft: ai.isSeft,
                                                    Batch: ai.batch,
                                                    ServeState: ai.serveState,
                                                    ChargedOnce: ai.chargedOnce,
                                                });
                                            }

                                        }
                                        this.groupCartList = [];
                                        this.groupCartBuffetList = [];
                                        for (var q = 0; q < dest.length; q++) {
                                            if (dest[q].isSeft == 0) {
                                                this.groupCartList.push(dest[q]);
                                            }
                                            else {
                                                this.groupCartBuffetList.push(dest[q]);
                                            }
                                        }
                                        this.cartShowData = this.groupOrerBy(this.groupCartList, (cart) => {
                                            return cart.foodTypeName
                                        });

                                        this.cartBuffetShowData = this.groupOrerBy(this.groupCartBuffetList, (cart) => {
                                            return cart.batch
                                        });
                                    }
                                    else {
                                        this.showOrderTip = true;
                                        this.cartShowData = [];
                                    }
                                });
                        }
                    });
            },
            selectOwerCartlist(index, list) {
                this.current = index;
                let groupCartList = [];
                let groupCartBuffetList = [];
                if (list != null) {
                    for (var q = 0; q < list.length; q++) {
                        if (list[q].isSeft == 0) {
                            groupCartList.push(list[q]);
                        }
                        else {
                            groupCartBuffetList.push(list[q]);
                        }
                    }
                }
                else {
                    groupCartList = this.groupCartList;
                    groupCartBuffetList = this.groupCartBuffetList;
                }
                if (groupCartList.length > 0) {
                    var total = 0;
                    groupCartList.forEach(function (item) {
                        total += Math.round(item.quantity * (item.foodDiscount * item.price));
                    });
                    this.total = total;

                    this.cartShowData = this.groupOrerBy(groupCartList, (cart) => {
                        return cart.foodTypeName
                    });
                }
                else {
                    this.cartShowData = [];
                }

                if (groupCartBuffetList.length > 0) {
                    this.cartBuffetShowData = this.groupOrerBy(groupCartBuffetList, (cart) => {
                        return cart.batch
                    });
                }
                else {
                    this.cartBuffetShowData = [];
                }
            },
            getTypeGroup(val) {
                return this.groupOrerBy(val, (cart) => {
                    return cart.foodTypeName
                });
            },
            getExpand(index) {
                var count = 0;
                for (var i in this.cartBuffetShowData) {
                    count++;
                }
                if ((index + 1) == count) {
                    return true;
                }
                return false;
            },
            getOrderTimes(times) {
                let txt = '';
                if (times == 1) {
                    txt = this.$t("orderList.frist");
                }
                else if (times == 2) {
                    txt = this.$t("orderList.second");
                }
                else if (times == 3) {
                    txt = this.$t("orderList.third");
                }
                else if (times == 4) {
                    txt = this.$t("orderList.fourth");
                }
                else {
                    txt = this.$t("orderList.moreth", { times: times } );
                }
                return txt;
            },
            addReminder() {
                this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                let param = {
                    RestaurantId: this.order.restaurantId,
                    OrderId: this.order.orderId,
                };
                this.$post('QRCodeOrder/OrderReminder', param)
                    .then(response => {
                        if (response.code==200) {
                            this.$alert(this.$t(response.data), this.$t("common.alert"), { okLabel: this.$t("common.sure") }); }
                    });
            },
            serviced() {
                let groupCartList = [];
                let groupCartBuffetList = [];
                this.groupCartList.forEach(function (item) {
                    if (item.serveState == 2) {
                        groupCartList.push(item);
                    }
                });
                this.cartShowData = this.groupOrerBy(groupCartList, (cart) => {
                    return cart.foodTypeName
                });

                this.groupCartBuffetList.forEach(function (item) {
                    if (item.serveState == 2) {
                        groupCartBuffetList.push(item);
                    }
                });
                this.cartBuffetShowData = this.groupOrerBy(groupCartBuffetList, (cart) => {
                    return cart.batch
                });
            },
            unServiced() {
                let groupCartList = [];
                let groupCartBuffetList = [];
                this.groupCartList.forEach(function (item) {
                    if (item.serveState !=2) {
                        groupCartList.push(item);
                    }
                });
                this.cartShowData = this.groupOrerBy(groupCartList, (cart) => {
                    return cart.foodTypeName
                });

                this.groupCartBuffetList.forEach(function (item) {
                    if (item.serveState !=2) {
                        groupCartBuffetList.push(item);
                    }
                });
                this.cartBuffetShowData = this.groupOrerBy(groupCartBuffetList, (cart) => {
                    return cart.batch
                });
            },
        },
        components: {
            cartcontrol
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .shopcart {
        position: fixed;
        max-width: 100%;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: 0;
        width: 100%;
        height: 48px;
        z-index: 260;
    }

    .shopcart .content {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            background: #141d27;
            color: rgba(255,255,255,0.4);
        }

        .shopcart .content .content-left {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            font-size: 0;
        }

                .shopcart .content .content-left .logo-wrapper {
                    padding: 6px;
                    margin: 0 12px;
                    background: #141d27;
                    width: 56px;
                    height: 56px;
                    display: inline-block;
                    position: relative;
                    top: -10px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    border-radius: 50%;
                }

                    .shopcart .content .content-left .logo-wrapper .logo {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        background: #2b343c;
                        text-align: center;
                        line-height: 44px;
                    }

                        .shopcart .content .content-left .logo-wrapper .logo .highlight {
                            background: #da5b3a;
                            z-index:450;
                        }

                        .shopcart .content .content-left .logo-wrapper .logo .icon-shopping_cart {
                            font-size: 24px;
                            line-height: 44px;
                            color: #80858a;
                        }

                            .shopcart .content .content-left .logo-wrapper .logo .icon-shopping_cart .highlight {
                                color: #fff;
                            }

                    .shopcart .content .content-left .logo-wrapper .num {
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 24px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;
                        border-radius: 16px;
                        font-size: 9px;
                        font-weight: 700;
                        color: #fff;
                        background: #f01414;
                        -webkit-box-shadow: 0 4px 8px 0 rgba(0,0,0,0.4);
                        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.4);
                        z-index:499;
                    }

                .shopcart .content .content-left .price {
                    display: inline-block;
                    height: 24px;
                    line-height: 24px;
                    vertical-align: top;
                    margin-top: 12px;
                    font-size: 16px;
                    font-weight: 700;
                    border-right: 1px solid rgba(255,255,255,0.1);
                    padding-right: 12px;
                }

                    .shopcart .content .content-left .price.highlight {
                        color: #fff;
                    }

                .shopcart .content .content-left .desc {
                    display: inline-block;
                    font-size: 14px;
                    line-height: 24px;
                    vertical-align: top;
                    margin: 12px 0 0 12px;
                    color:#fff;
                }

            .shopcart .content .content-right {
                -webkit-box-flex: 0;
                -ms-flex: 0 0 105px;
                flex: 0 0 105px;
                width: 105px;
            }

                .shopcart .content .content-right .pay {
                    height: 48px;
                    line-height: 48px;
                    font-size: 12px;
                    font-weight: 700;
                    text-align: center;
                }

                    .shopcart .content .content-right .pay.not-enough {
                        background: #f44336;
                        color: #fff;
                    }

                    .shopcart .content .content-right .pay.enough {
                        background: #4caf50;
                        color: #fff;
                    }

    .form-onlyread {
        pointer-events: none;
        background: #9e9e9e;
    }

        .shopcart .ball-container .ball {
            position: fixed;
            left: 32px;
            bottom: 22px;
            z-index: 300;
        }

            .shopcart .ball-container .ball.drop-enter,
            .shopcart .ball-container .ball.drop-enter-active {
                -webkit-transition: all 0.4s cubic-bezier(0.49, -0.29, 0.75, 0.41);
                transition: all 0.4s cubic-bezier(0.49, -0.29, 0.75, 0.41);
            }

            .shopcart .ball-container .ball .inner {
                display: inline-block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #da5b3a;
                -webkit-transition: all 0.4s linear;
                transition: all 0.4s linear;
            }

        .shopcart .shopcart-list {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            z-index: -1;
            -webkit-transform: translate3d(0, -100%, 0);
            transform: translate3d(0, -100%, 0);
        }

            .shopcart .shopcart-list.fold-enter-active,
            .shopcart .shopcart-list.fold-leave-active {
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
            }

            .shopcart .shopcart-list.fold-enter,
            .shopcart .shopcart-list.fold-leave-to {
                -webkit-transform: translate3d(0, 0, 0);
                transform: translate3d(0, 0, 0);
            }

        .shopcart .list-header {
            height: 40px;
            line-height: 40px;
            padding: 0 18px;
            background: #f3f5f7;
            border-bottom: 1px solid rgba(7,17,27,0.1);
        }

            .shopcart .list-header .title {
                font-size: 14px;
                float: left;
                color: #07111b;
                font-weight:600;
            }
            .shopcart .list-header .empty {
                float: right;
                font-size: 12px;
                color: #00a0dc;
            }

        .shopcart .list-content {
            padding: 0 18px;
            max-height: 217px;
            background: #fff;
            overflow-y: scroll;
        }

            .shopcart .list-content .food {
                position: relative;
                padding: 12px 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                position: relative;
                overflow: hidden;
            }

                .shopcart .list-content .food:after {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    border-top: 1px solid rgba(7,17,27,0.1);
                    content: '';
                }

                .shopcart .list-content .food:last-child:after {
                    border-top: 0;
                }

                .shopcart .list-content .food .name {
                    line-height: 28px;
                    font-size: 14px;
                    color: #07111b;
                    width:60%;
                }
                .shopcart .list-content .food .decide-name {
                    line-height: 22px;
                    font-size: 12px;
                    color: #b0bec5;
                }
    .shopcart .list-content .food .price {
        position: absolute;
        right: 90px;
        bottom: 12px;
        line-height: 28px;
        font-size: 14px;
        font-weight: bold;
        color: #f01414;
    }

                .shopcart .list-content .food .cartcontrol-wrapper {
                    position: absolute;
                    right: 0;
                    bottom: 6px;
                }

        .shopcart .list-mask {
            position: fixed;
            max-width: 100%;
            top: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 100%;
            height: 100%;
            background: rgba(7,17,27,0.6);
            -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
            z-index: -2;
            opacity: 1;
        }

            .shopcart .list-mask.mask-fade-enter-active,
            .shopcart .list-mask.mask-fade-leave-active {
                -webkit-transition: all 0.3s;
                transition: all 0.3s;
            }

            .shopcart .list-mask.mask-fade-enter,
            .shopcart .list-mask.mask-fade-leave-to {
                opacity: 0;
            }


    element.style {
    }

    .mu-item.has-avatar {
        height: 56px;
    }

    .mu-item {
        height: 48px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 5px;
        color: rgba(0,0,0,.87);
    }
    .cart-box {
        position: relative;
        margin: auto;
        background-color: #fff;
        background-size: cover;
        overflow-y: unset;
    }

    .table-info-keywords {
        color: #e53935;
        font-size: 18px;
        font-weight: 600;
        margin-left: 10px;
    }

    .table-info-list-title {
        text-align: center;
        font-size: 16px;
        color: #4fc3f7;
    }

    .now {
        font-size: 12px;
        color: #f01414;
        font-weight: 700;
        line-height: 24px;
        margin-right: 8px;
    }

    .old {
        font-size: 12px;
        text-decoration: line-through;
        color: #93999f;
        font-weight: 700;
        line-height: 24px;
    }

    .ower {
        position: relative;
        z-index: 9;
        padding: 10px;
        background-color: #fff;
    }

    .badge-num {
        float: left;
        width: 60px;
        height: 32px;
        margin-right: 5px;
        margin-bottom: 5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 6px;
        line-height: 1.5;
        font-size: 14px;
        font-style: normal;
        background-color: #bdbdbd;
        color: #fff;
        border-radius: 3px;
        overflow: hidden;
    }

    .select {
        background-color: rgb(218, 91, 58);
    }

    .btn-home {
        position: fixed;
        bottom: 10px;
        left: 10px;
        background-color: #da5b3a !important;
        text-transform: unset;
    }


    .marker-red {
        width: 10px;
        height: 10px;
        border: 1px solid rgb(244, 67, 54);
        border-radius: 10px;
        background-color: rgb(244, 67, 54);
        opacity: 1;
    }
    .marker-green {
        width: 10px;
        height: 10px;
        border: 1px solid #4caf50;
        border-radius: 10px;
        background-color: #4caf50;
        opacity: 1;
    }

    .oprations {
        position: fixed;
        bottom: 0;
        right: 0;
    }

        .oprations .oprations-btn {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 105px;
            flex: 0 0 105px;
            width: 105px;
            float: left;
        }

            .oprations .oprations-btn .oprations-back {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                background-color: #bdbdbd;
                color: #fff;
                float: right;
                width: 100%;
            }

            .oprations .oprations-btn .oprations-next {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                float: right;
                width: 100%;
            }

                .oprations .oprations-btn .oprations-next.not-enough {
                    background: #f44336;
                    color: #fff;
                }

                .oprations .oprations-btn .oprations-next.enough {
                    background: #4caf50;
                    color: #fff;
                }


</style>



// WEBPACK FOOTER //
// src/components/ShopCart.vue